import Sortable from 'sortablejs';
import { mount } from '../../../js/dom-lifecycle';

mount('[data-sortable]', function () {
    const url = this.dataset.sortable;
    Sortable.create(this, {
        handle: '.drag-handle',
        animation: 150,
        onEnd: function (evt) {
            if (evt.newIndex == evt.oldIndex) {
                return;
            }
            this.option("disabled", true);
            $.post(url, {
                _token: this.el.dataset.csrfToken,
                id: evt.item.dataset.id,
                position: evt.newIndex > evt.oldIndex ? 'after' : 'before',
                target: evt.newIndex > evt.oldIndex ?
                    evt.item.previousElementSibling.dataset.id :
                    evt.item.nextElementSibling.dataset.id
            }).fail(() => {
                const siblings = Array.from(evt.from.children).filter(c => c !== evt.item);
                const referenceNode = siblings[evt.oldIndex] || null;
                evt.from.insertBefore(evt.item, referenceNode);
            }).always(() => {
                this.option("disabled", false);
            });
        }
    });
});
